import { LockKeyhole } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import Image from 'assets/images/questionnaire/questionnaire.png';
import { PATH_ROUTES } from 'routes/path';
import { ScrollArea } from 'components/ui/scroll-area';

export default function CompleteQuestionnaire({
  isAllEmpty,
  onView,
}: {
  isAllEmpty: boolean;
  onView: () => void;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='px-4 my-4 ml-4 mr-4 border rounded-md shadow-sm sm:ml-0'>
      <ScrollArea className='h-full sm:h-[calc(100vh-5rem)] lg:h-[calc(100vh-2.5rem)]'>
        <div className='relative grid h-full grid-cols-1 gap-4 pb-4 space-y-4 xl:grid-cols-2'>
          <div className='flex flex-col justify-center order-2 h-full space-y-6 sm:px-4 lg:px-6 xl:px-12 xl:order-1'>
            <div className='space-y-2'>
              <h1 className='text-xl font-semibold text-center md:text-start'>
                {t('complete_questionnaire_title')}
              </h1>
              <p className='font-medium text-gray-600'>
                {t('complete_questionnaire_desc')}
              </p>
            </div>

            <div className='p-4 space-y-2 text-sm rounded-lg bg-tertiary/10'>
              <div className='flex items-center justify-between'>
                <h4 className='font-semibold text-tertiary'>
                  {t('questionnaire_privacy_title')}
                </h4>
                <LockKeyhole className='text-tertiary size-4' />
              </div>
              <p className='font-medium text-gray-600'>
                {t('questionnaire_privacy_desc')}
              </p>
            </div>

            <div className='flex flex-col items-center justify-center gap-4 lg:flex-row'>
              {!isAllEmpty ? (
                <Button
                  variant='outline'
                  size='sm'
                  className='w-full px-6 border-gray-600 lg:w-auto'
                  onClick={onView}
                >
                  {t('view_questionnaire')}
                </Button>
              ) : null}
              <Button
                size='sm'
                className='w-full px-6 lg:w-auto'
                onClick={() => navigate(PATH_ROUTES.QUESTIONNAIRE)}
              >
                {isAllEmpty ? t('start') : t('complete')} {t('questinnaire')}
              </Button>
            </div>
          </div>
          <div className='flex items-center justify-center order-1 xl:order-2'>
            <img
              src={Image}
              alt='question'
              className='object-cover h-[200px] xl:h-3/5 aspect-square'
            />
          </div>
        </div>
      </ScrollArea>
    </div>
  );
}
